module.exports = __webpack_public_path__ + "img/puptitle4.d818e8c4.png";